import { formatQuantity } from 'format-quantity'
import slugify from '@sindresorhus/slugify'
import { useState } from 'react'
import { Checkbox } from '../ui/checkbox.tsx'

export default function Ingredient({
	name,
	quantity,
	units,
}: {
	name: string
	quantity: string | number
	units: string
}) {
	const id = slugify(name)
	const [checked, setChecked] = useState(false)
	let linedThrough = checked ? 'line-through ' : ''
	return (
		<div className={`relative flex items-start`} key={id}>
			<div className="flex h-6 items-center">
				<Checkbox
					id={id}
					name={id}
					onCheckedChange={() => setChecked(!checked)}
				/>
				{/* <input
					id={id}
					name={id}
					type="checkbox"
					className="focus:ring-secondary h-4 w-4 rounded border-gray-300 text-primary"
					onChange={() => setChecked(!checked)}
				/> */}
			</div>
			<div className="ml-3 leading-6">
				<label htmlFor={id} className={`${linedThrough}`}>
					{quantity && (
						<span className="quantity">
							{typeof quantity === 'number'
								? formatQuantity(quantity, true)
								: quantity}{' '}
						</span>
					)}
					{units && <span className="units">{units} </span>}
					{name}
				</label>
			</div>
		</div>
	)
}
